import { useState, useEffect } from 'react';
import type { SyncEngine, SyncStatus } from '../sync/SyncEngine';

const INITIAL_STATUS: SyncStatus = {
  pendingCount: 0,
  failedCount: 0,
  isSyncing: false,
  lastSyncAt: null,
  lastError: null,
};

/**
 * React hook for sync engine status.
 */
export function useSyncStatus(engine: SyncEngine | null): SyncStatus {
  const [status, setStatus] = useState<SyncStatus>(INITIAL_STATUS);

  useEffect(() => {
    if (!engine) return;
    return engine.onStatusChange(setStatus);
  }, [engine]);

  return status;
}
